// extracted by mini-css-extract-plugin
export var bottomContainer = "D_cK";
export var buttons = "D_cr";
export var icon = "D_bq";
export var link = "D_bx";
export var section = "D_d";
export var social = "D_cJ";
export var text = "D_b0";
export var title = "D_h";
export var topContainer = "D_cH";
export var videoContainer = "D_cF";
export var videoWrapper = "D_cG";